<script setup lang="ts">
import { watch } from 'vue'
import { KsSpinner } from '@aschehoug/kloss'
import { setTitle } from '~/utils/dom'
import useLicenseControlStore from '~/stores/licenseControl'
import { ColorName, ColorTheme } from '~/models/Content/Color'
import useFormWriter from '~/composables/useFormWriter'
import { useColorTheme } from '~/composables/useColorTheme'
import { useAppColor } from '~/composables/useAppColor'
import TopBar from '~/components/utils/TopBar.vue'
import NotFound from '~/components/ResourceEngine/Components/NotFound.vue'
import FormWriter from '~/components/formwriter/FormWriter.vue'

const { locationId } = defineProps<{ locationId: number }>()

useAppColor(ColorName.Orange5)
const { style } = useColorTheme(ColorTheme.BlueOrange)

const { checkItemLicense } = useLicenseControlStore()

const { data, isLoadingFormData, isError } = useFormWriter(locationId)

watch(data, () => {
  if (!data.value)
    return
  setTitle(data.value.title)
  checkItemLicense(data.value)
}, { immediate: true })
</script>

<template>
  <div class="mx-auto flex size-full max-w-screen-sm flex-col items-center px-4 py-20 sm:px-8 lg:max-w-screen-md" :style>
    <NotFound v-if="isError" />
    <KsSpinner v-else-if="isLoadingFormData" />
    <template v-else-if="data">
      <TopBar :item="data" />
      <FormWriter :item="data" />
    </template>
  </div>
</template>
